import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import GuestLookup from './pages/GuestLookup';
import AdminDashboard from './pages/AdminDashboard';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Faqja publike per çdo dasme — kjo hapet kur mysafiri skanon QR-in e vet */}
        <Route path="/e/:slug" element={<GuestLookup />} />

        {/* Kycja */}
        <Route path="/admin/login" element={<Login />} />

        {/* Paneli i mbrojtur — admin (menaxhon klientet) ose klient (tavolina/mysafire) */}
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />

        {/* Rrenja e faqes çon te kycja */}
        <Route path="/" element={<Navigate to="/admin/login" replace />} />
        <Route path="*" element={<Navigate to="/admin/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
